import {CsmService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _CsmService = new CsmService({client});
export {_CsmService as CsmService};
